import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#leasing

	{
        "antragstellerIds": [ String ],
        "datumLetzteRate": LocalDate,
        "glaeubiger": String,
        "rateMonatlich": BigDecimal,
        "schlussrate": BigDecimal
    }

*/
export const schemaEuropaceUpdateLeasing = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    datumLetzteRate: z.optional(z.string().regex(regex_iso_date)),
    glaeubiger: z.optional(z.string()),
    rateMonatlich: z.optional(schemaBigDecimal),
    schlussrate: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateLeasing = z.infer<typeof schemaEuropaceUpdateLeasing>;
